import { Button as SemanticButton, type ButtonProps, type SemanticSIZES } from "semantic-ui-react";
import { type IconDefinition, type SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { semanticToFaSize } from "./size-mapping";
import styles from "./Button.module.scss";
import cn from "classnames";

export interface Props extends ButtonProps {
  blur?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void | Promise<void>;
  icon?: IconDefinition;
  iconPosition?: "left" | "right";
  borderless?: boolean;
  height?: "auto" | "default";
}

export const Button: React.FC<Props> = ({
  onClick,
  children,
  blur,
  icon,
  borderless,
  iconPosition = "left",
  size,
  className,
  content,
  ...other
}) => {
  const onClickAction = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => {
    onClick?.(e, data);
    if (blur) e.currentTarget.blur();
  };

  const faSize: SizeProp | undefined = size ? semanticToFaSize[size as SemanticSIZES] : undefined;

  return (
    <SemanticButton
      onClick={onClickAction}
      size={size}
      className={cn(className, { [styles.borderless]: borderless })}
      {...other}
    >
      {icon && iconPosition === "left" && <FontAwesomeIcon size={faSize ?? "lg"} className={styles.icon} icon={icon} />}
      {content || children}
      {icon && iconPosition === "right" && (
        <FontAwesomeIcon size={faSize ?? "lg"} className={styles.icon} icon={icon} />
      )}
    </SemanticButton>
  );
};
